import { render, staticRenderFns } from "./topUp.vue?vue&type=template&id=0c20ff5f&scoped=true"
import script from "./topUp.vue?vue&type=script&lang=js"
export * from "./topUp.vue?vue&type=script&lang=js"
import style0 from "./topUp.vue?vue&type=style&index=0&id=0c20ff5f&prod&lang=less&scoped=true"
import style1 from "./topUp.vue?vue&type=style&index=1&id=0c20ff5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20ff5f",
  null
  
)

export default component.exports